const localStorageApplicationsData = JSON.parse(localStorage.getItem('APPLICATION_DATA') || '[]');

const mockData = [
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-14 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 1,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-14 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-14 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 1,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-14 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-14 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 2,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-14 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-13 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 3,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-13 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-13 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 4,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-13 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-13 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 5,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-13 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-12 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 6,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-12 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-12 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 7,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-12 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-12 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 8,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-12 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-11 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 9,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-11 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-11 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 10,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-11 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-11 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 11,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-11 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-10 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 12,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-10 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-10 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 13,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-10 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-10 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 14,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-10 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-09 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 15,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-09 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-09 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 16,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-09 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-09 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 17,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-09 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-08 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 18,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-08 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-08 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 19,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-08 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-08 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 20,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-08 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-07 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 21,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-07 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-07 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 22,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-07 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-07 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 23,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-07 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-06 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 24,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-06 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-06 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 25,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-06 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-06 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 26,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-06 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-05 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 27,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-05 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-05 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 28,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-05 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-05 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 29,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-05 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-04 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 30,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-04 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-04 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 31,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-04 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-04 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 32,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-04 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-03 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 33,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-03 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-03 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 34,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-03 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-03 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 35,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-03 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-02 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 36,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-02 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-02 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 37,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-02 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-02 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 38,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-02 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-01 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 39,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-01 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-01 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 40,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-01 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-06-01 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 41,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-06-01 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-31 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 42,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-31 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-31 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 43,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-31 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-31 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 44,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-31 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-30 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 45,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-30 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-30 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 46,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-30 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-30 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 47,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-30 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-29 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 48,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-29 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-29 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 49,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-29 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-29 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 50,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-29 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-28 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 51,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-28 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-28 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 52,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-28 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-28 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 53,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-28 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-27 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 54,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-27 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-27 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 55,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-27 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-27 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 56,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-27 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-26 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 57,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-26 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-26 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 58,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-26 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-26 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 59,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-26 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-25 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 60,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-25 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-25 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 61,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-25 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-25 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 62,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-25 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-24 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 63,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-24 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-24 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 64,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-24 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-24 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 65,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-24 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-23 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 66,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-23 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-23 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 67,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-23 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-23 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 68,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-23 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-22 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 69,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-22 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-22 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 70,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-22 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-22 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 71,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-22 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-21 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 72,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-21 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-21 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 72,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-21 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-21 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 73,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-21 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-20 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 74,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-20 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-20 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 75,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-20 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-20 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 76,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-20 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-19 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 77,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-19 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-19 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 78,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-19 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-19 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 79,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-19 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-18 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 80,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-18 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-18 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 81,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-18 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-18 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 82,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-18 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-17 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 83,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-17 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-17 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 84,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-17 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-17 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 85,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-17 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-16 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 86,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-16 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-16 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 87,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-16 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-16 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 88,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-16 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-15 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 89,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-15 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-15 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 90,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-15 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-15 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 91,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-15 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-14 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 92,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-14 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-14 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 93,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-14 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-14 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 94,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-14 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-13 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 95,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-13 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-13 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 96,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-13 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-13 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 97,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-13 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-12 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 98,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-12 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-12 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 99,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-12 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-12 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 100,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-12 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-11 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 101,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-11 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-11 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 102,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-11 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-11 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 103,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-11 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-10 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 104,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-10 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-10 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 105,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-10 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-10 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 106,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-10 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-09 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 107,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-09 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-09 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 108,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-09 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-09 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 109,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-09 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-08 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 110,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-08 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-08 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 111,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-08 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-08 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 112,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-08 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-07 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 113,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-07 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-07 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 114,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-07 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-07 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 115,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-07 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-06 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 116,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-06 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-06 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 117,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-06 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-06 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 118,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-06 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-05 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 119,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-05 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-05 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 120,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-05 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-05 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 121,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-05 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-04 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 122,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-04 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-04 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 123,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-04 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-04 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 124,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-04 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-03 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 125,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-03 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-03 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 126,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-03 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-03 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 127,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-03 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-02 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 128,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-02 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-02 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 129,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-02 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-02 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 130,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-02 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-01 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 131,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-01 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-01 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 132,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-01 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-05-01 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 133,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-05-01 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-30 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 134,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-30 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-30 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 135,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-30 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-30 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 136,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-30 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-29 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 137,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-29 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-29 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 138,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-29 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-29 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 139,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-29 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-28 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 140,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-28 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-28 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 141,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-28 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-28 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 142,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-28 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-27 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 143,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-27 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-27 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 144,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-27 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-27 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 145,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-27 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-26 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 146,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-26 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-26 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 147,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-26 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-26 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 148,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-26 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-25 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 149,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-25 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-25 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 150,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-25 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-25 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 151,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-25 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-24 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 152,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-24 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-24 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 153,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-24 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-24 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 154,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-24 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-23 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 155,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-23 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-23 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 156,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-23 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-23 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 157,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-23 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-22 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 158,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-22 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-22 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 159,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-22 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-22 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 160,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-22 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-21 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 161,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-21 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-21 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 162,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-21 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-21 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 163,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-21 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-20 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 164,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-20 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-20 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 165,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-20 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-20 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 166,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-20 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-19 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 167,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-19 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-19 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 168,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-19 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-19 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 169,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-19 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-18 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 170,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-18 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-18 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 170,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-18 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-18 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 171,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-18 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-17 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 172,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-17 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-17 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 173,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-17 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-17 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 174,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-17 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-16 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 175,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-16 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-16 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 176,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-16 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-16 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 177,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-16 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-15 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 178,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-15 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-15 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 179,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-15 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-15 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 180,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-15 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-14 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 181,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-14 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-14 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 182,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-14 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-14 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 183,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-14 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-13 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 184,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-13 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-13 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 185,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-13 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-13 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 186,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-13 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-12 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 187,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-12 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-12 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 188,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-12 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-12 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 189,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-12 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-11 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 190,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-11 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-11 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 191,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-11 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-11 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 192,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-11 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-10 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 193,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-10 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-10 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 194,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-10 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-10 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 195,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-10 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-09 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 196,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-09 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-09 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 197,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-09 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-09 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 198,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-09 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-08 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 199,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-08 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-08 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 200,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-08 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-08 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 201,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-08 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-07 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 202,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-07 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-07 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 203,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-07 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-07 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 204,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-07 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-06 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 205,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-06 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-06 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 206,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-06 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-06 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 207,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-06 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-05 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 208,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-05 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-05 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 209,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-05 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-05 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 210,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-05 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-04 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 211,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-04 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-04 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 212,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-04 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-04 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 213,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-04 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-03 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 214,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-03 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-03 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 215,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-03 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-03 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 216,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-03 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-02 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 217,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-02 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-02 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 218,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-02 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-02 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 219,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-02 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-01 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 220,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-01 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-01 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 221,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-01 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-04-01 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 222,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-04-01 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-31 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 223,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-31 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-31 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 224,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-31 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-31 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 225,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-31 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-30 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 226,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-30 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-30 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 227,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-30 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-30 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 228,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-30 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-29 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 229,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-29 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-29 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 230,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-29 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-29 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 231,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-29 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-28 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 232,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-28 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-28 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 233,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-28 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-28 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 234,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-28 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-27 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 235,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-27 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-27 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 236,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-27 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-27 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 237,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-27 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-26 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 238,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-26 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-26 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 239,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-26 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-26 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 240,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-26 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-25 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 241,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-25 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-25 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 242,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-25 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-25 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 243,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-25 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-24 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 244,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-24 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-24 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 245,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-24 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-24 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 246,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-24 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-23 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 247,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-23 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-23 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 248,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-23 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-23 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 249,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-23 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-22 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 250,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-22 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-22 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 251,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-22 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-22 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 252,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-22 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-21 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 253,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-21 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-21 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 254,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-21 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-21 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 255,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-21 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-20 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 256,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-20 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-20 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 257,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-20 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-20 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 258,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-20 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-19 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 259,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-19 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-19 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 260,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-19 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-19 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 261,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-19 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-18 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 262,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-18 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-18 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 263,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-18 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-18 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 264,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-18 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-17 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 265,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-17 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-17 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 266,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-17 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-17 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 267,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-17 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-16 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 268,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-16 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-16 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 269,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-16 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-16 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 270,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-16 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-15 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 271,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-15 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-15 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 272,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-15 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-15 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 273,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-15 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-14 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 274,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-14 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-14 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 275,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-14 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-14 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 276,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-14 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-13 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 277,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-13 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-13 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 278,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-13 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-13 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 279,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-13 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-12 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 280,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-12 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-12 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 281,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-12 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-12 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 282,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-12 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-11 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 283,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-11 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-11 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 284,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-11 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-11 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 285,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-11 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-10 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 286,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-10 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-10 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 287,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-10 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-10 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 288,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-10 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-09 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 289,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-09 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-09 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 290,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-09 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-09 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 291,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-09 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-08 15:46:07',
    approvalStatus: '승인대기',
    reason: '',
    serial: 292,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-08 15:46:07',
  },
  {
    previousType: '소득적격',
    applicationType: '개인전문',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-08 15:46:07',
    approvalStatus: '승인거부',
    reason: '서류 식별 불가 금융투자업자에 계좌를 개설한지 1년 미만으로 전문투자자 승인 불가',
    serial: 293,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-08 15:46:07',
  },
  {
    previousType: '일반개인',
    applicationType: '소득적격',
    number: 'abc1',
    name: '',
    docs: [
      {
        url: 'https://shorturl.at/dlCT2',
        ext: 'png',
      },
    ],
    applicationDate: '2023-03-08 15:46:07',
    approvalStatus: '승인완료',
    reason: '',
    serial: 294,
    checked: false,
    admin: '김관리자',
    approvalDate: '2023-03-08 15:46:07',
  },
];
// Create a lookup table based on serial numbers
const lookupTable = {};

// Merge the arrays and deduplicate based on serial number
const ApplicationsData = localStorageApplicationsData.concat(mockData).filter((obj) => {
  if (!lookupTable[obj.serial]) {
    lookupTable[obj.serial] = true;
    return true;
  }
  return false;
});

export default ApplicationsData;
